import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Layout from "../../components/layout";

import { getVideosList, selectVideosList } from "../../ducks/videos";

import Styles from "./videos-list.module.scss";

class VideosList extends Component {
    componentDidMount() {
        this.props.getVideosList();
    }

    render() {
        const { videos } = this.props;
        const list = videos ? 
            videos.map(v => (
                <Layout.Tile key={v.meta.Id}>
                    <Link to={`/video/${v.meta.Id}`}>
                        <h3>{v.meta.FileName}</h3>
                        <div>{v.meta.Size}</div>
                        <div>{v.meta.Id}</div>
                    </Link>
                </Layout.Tile>
            ))
        : <span>Fetching videos...</span>
        return (
            <Layout.Page>
                <h2>Videos</h2>
                <Layout.TileContainer>
                    {list}
                </Layout.TileContainer>
            </Layout.Page>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        videos: selectVideosList(state),
    };
};
const mapDispatchToProps = {
    getVideosList,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VideosList);



// WEBPACK FOOTER //
// ./src/pages/videos-list/videos-list.js